export function base64ToUint8Array(base64) {
    const binary = atob(base64);
    const len = binary.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binary.charCodeAt(i);
    }
    return arr;
}
